import { Checkbox, Row } from 'antd';
import styled from 'styled-components';

export const StyledTransportColorCircle = styled.div<{ $color?: string }>`
  width: 15px;
  height: 15px;
  background: ${({ $color = '#000' }) => $color};
  border-radius: 50%;
  position: absolute;
  top: 15px;
  right: 10px;
`;

export const StyledCheckbox = styled(Checkbox)`
  margin-right: 6px;
  margin-left: -14px;
  padding: 10px;
`;

export const StyledTopRow = styled(Row)`
  padding: 12px 10px 12px 24px;
  position: sticky;
  top: 0;
  z-index: 1;
  background: #fff;
`;
